export default __webpack_public_path__ + "static/media/welcome-page-3.a2772410.png";